export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Bold-5db50830eb2ed8555b96888f9c86ceae.woff2";